/** 将子资源 code → 数量 组装为询价约定的 JSON 字符串 */
export function stringifySubResourceQuantities(quantities: Record<string, string | number | undefined | null>): string | undefined {
  const normalized: Record<string, string> = {};
  for (const [code, raw] of Object.entries(quantities || {})) {
    const key = String(code || '').trim();
    if (!key) continue;
    if (raw == null || raw === '') continue;
    const qty = String(raw).trim();
    if (!qty) continue;
    normalized[key] = qty;
  }
  if (!Object.keys(normalized).length) return undefined;
  return JSON.stringify(normalized);
}

/** 是否开启子资源计价 */
export function isSubResourcePricingEnabled(
  relation?: {
    useSubResourcePricing?: boolean;
    subResourceConfigs?: unknown[];
  } | null,
): boolean {
  return Boolean(relation?.useSubResourcePricing && Array.isArray(relation?.subResourceConfigs) && relation.subResourceConfigs.length > 0);
}

/** 从 resourceName（如 Token/InputToken）拆出父级 / 子级 */
export function splitSubResourceName(resourceName?: string): { parent?: string; sub?: string; isSub: boolean } {
  const name = String(resourceName || '').trim();
  if (!name) return { isSub: false };
  const idx = name.indexOf('/');
  if (idx <= 0 || idx >= name.length - 1) return { parent: name, isSub: false };
  return {
    parent: name.slice(0, idx),
    sub: name.slice(idx + 1),
    isSub: true,
  };
}
